import React, { useEffect, useState } from "react";

import { getCookie } from "../../utils/utility-functions";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTE_CONSTANT } from "../../routing/route-constants";
import Footer from "../../components/footer";
import Header from "../../components/header";
import Tabs from "../../components/tab";
import AdminUserDetails from "../admin-user-details";
import AdminUserDocuments from "../admin-user-documents/";
import AdminReactivateUser from "../admin-reactivate-user";
import UpdateUserEmai from "../emailid-update-user";
import UpdateUserPassword from "../admin-update-user-password";
import Loader from "../../components/loader";

function AdminSearch({ funnelStep }) {
  const { isAuth } = funnelStep;
  // const token = isAuth === true;
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = funnelStep || {};
  // Extract query parameter for step
  const searchParams = new URLSearchParams(location.search);
  const stepParam = searchParams.get("step") || "tab1";
  const [activeStep, setActiveStep] = useState(stepParam);
  const [isAuthorized, setIsAuthorized] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isAuth) {
      navigate(ROUTE_CONSTANT.ADMIN_LOGIN);
    } else {
      setIsLoading(false);
    }
  }, [isAuth]);
  const tabData = [
    {
      id: "tab1",
      label: "Users Details",
      content: <AdminUserDetails />,
      onClick: () => handleTabChange("tab1"),
    },
    {
      id: "tab2",
      label: "Recent Document",
      content: <AdminUserDocuments />,
      onClick: () => handleTabChange("tab2"),
    },
    {
      id: "tab3",
      label: "User Operations",
      content: <AdminReactivateUser />,
      onClick: () => handleTabChange("tab3"),
    },
    {
      id: "tab4",
      label: "Update User Email",
      content: <UpdateUserEmai />,
      onClick: () => handleTabChange("tab4"),
    },
    {
      id: "tab5",
      label: "Update User Password",
      content: <UpdateUserPassword />,
      onClick: () => handleTabChange("tab5"),
    },
  ];
  const handleTabChange = (tabId) => {
    setActiveStep(tabId);
    searchParams.set("step", tabId);
    navigate(`?${searchParams.toString()}`, { replace: true });
  };
  return (
    <>
      {" "}
      <Header />
      <div className="w-full flex justify-center items-center">
        <div className="m-10 w-full flex flex-col gap-4">
          {isLoading ? (
            <Loader isLoading={isLoading} />
          ) : isAuthorized ? (
            <Tabs
              tabs={tabData}
              initialTab={activeStep}
              onTabClick={handleTabChange}
            />
          ) : (
            <div
              className="border-4 border-red-700 font-bold text-red-700 text-center flex flex-col items-center justify-center"
              style={{
                height: "200px",
                width: "300px",
                margin: "auto",
                marginTop: "20vh",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-12 w-12 mb-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
                style={{ color: "#FFD700" }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10.29 3.86L1.82 18c-.78 1.35.2 3 1.71 3h16.94c1.51 0 2.49-1.65 1.71-3l-8.47-14.14a2 2 0 00-3.42 0zM12 9v4m0 4h.01"
                />
              </svg>
              Shoot!! You do not have access.
            </div>
          )}
        </div>
      </div>{" "}
      <Footer className="fixed" />
    </>
  );
}

export default AdminSearch;
